/* topiary category page, desktop (7 Oct 2026; plan Docs/category-page-build-plan-2026-10-07.md).
   Works with the theme's own filter engine (assets/facets.js); never replaces it.
   - At 1025 px and up (and only where the browser supports :has, matching the stylesheet), the filter drawer becomes a static
     column: drawer state, focus trap and dialog semantics are cleared; groups open. Below 1025 px everything is restored:
     dialog role, closed groups we opened, focus moved to a visible control (Codex plan review, drawer lifecycle).
   - The desktop sort select checks the drawer form's matching sort_by radio and fires `input`, so facets.js runs as usual.
   - Counts ("Filter (N products)", "Showing x of y"), the guide band position and the per-row ratings space are re-applied
     after every re-render: facets.js replaces the grid and filter groups; "Load more" rebuilds the whole listing. */
(function () {
  'use strict';
  // Every device (James, 8 Oct): with a colour filter on, products with no photo in the chosen colour are not rendered; each page
  // of the listing carries how many (data-tp-hidden), and the theme's "N products" line is corrected to count only what is shown.
  function hiddenCount(root) {
    var n = 0;
    (root || document).querySelectorAll('[product-listing-wrapper] [data-tp-hidden]').forEach(function (s) { n += parseInt(s.getAttribute('data-tp-hidden'), 10) || 0; });
    return n;
  }
  function shopifyTotal(root) {                               // the grid's marker: facets.js re-renders the grid (empty results too), not the count line's attributes
    var el = (root || document).querySelector('.main-collection-section [data-section_id] > .tp-total-raw') ||
             (root || document).querySelector('.main-collection-section [total-product-count]');
    var raw = el && parseInt(el.getAttribute('data-tp-total-raw'), 10);
    return isNaN(raw) ? null : raw;
  }
  function fixCountLine() {
    var el = document.querySelector('.main-collection-section [total-product-count]');
    var raw = shopifyTotal();
    if (!el || raw === null) return;
    var n = Math.max(0, raw - hiddenCount());
    var t = n + (n === 1 ? ' product' : ' products');
    if (el.textContent !== t) el.textContent = t;                 // write only when different (an observer watches this node)
  }
  var countRaf = 0;
  function fixCountLineSoon() { cancelAnimationFrame(countRaf); countRaf = requestAnimationFrame(fixCountLine); }
  var sec0 = document.querySelector('.main-collection-section');
  if (sec0) {
    fixCountLine();
    new MutationObserver(fixCountLineSoon).observe(sec0, { childList: true, subtree: true });
  }

  var DESKTOP = window.matchMedia('(min-width: 1025px)');
  var SUPPORTS = !!(window.CSS && CSS.supports && CSS.supports('selector(:has(*))'));
  if (!SUPPORTS) return;

  var section = document.querySelector('.main-collection-section');
  if (!section) return;
  var mounted = false;

  function form() { return section.querySelector('facet-filters-form[data-type="vertical"]'); }
  function listing() { return section.querySelector('[product-listing-wrapper]'); }

  // The theme keeps one global focus trap. Remember which element owns it, so switching to the desktop column clears only the
  // filter drawer's trap and never another drawer's (an open cart keeps its trap; Codex category gate r1).
  var trapOwner = null;
  if (typeof window.removeTrapFocus === 'function') {
    var origRemove = window.removeTrapFocus;
    window.removeTrapFocus = function () { trapOwner = null; return origRemove.apply(this, arguments); };
  }
  // A keyboard-opened drawer schedules trapFocus(el) after 500 ms; if the window has since crossed to desktop, ignore it.
  if (typeof window.trapFocus === 'function') {
    var origTrap = window.trapFocus;
    window.trapFocus = function (el) {
      if (DESKTOP.matches && el && el.matches && el.matches('facet-filters-form[data-type="vertical"]')) return;
      var r = origTrap.apply(this, arguments);
      trapOwner = el || null;
      return r;
    };
  }

  function openGroups() {
    var f = form(); if (!f) return;
    f.querySelectorAll('details[data-js-filter]:not(.collection-filter-sort)').forEach(function (d) {
      if (!d.open) { d.open = true; d.setAttribute('data-tp-opened', ''); }
    });
  }

  function mount() {
    var f = form(); if (!f) return;
    if (f.classList.contains('expanded')) {
      f.classList.remove('expanded');
      document.body.classList.remove('overflow-hidden');
    }
    if (trapOwner && (trapOwner === f || f.contains(trapOwner)) && typeof window.removeTrapFocus === 'function') {
      try { window.removeTrapFocus(); } catch (e) {}
    }
    if (!f.hasAttribute('data-tp-role')) f.setAttribute('data-tp-role', f.getAttribute('role') || '');
    if (!f.hasAttribute('data-tp-tabindex')) f.setAttribute('data-tp-tabindex', f.getAttribute('tabindex') || '');
    f.removeAttribute('role');
    f.removeAttribute('tabindex');
    openGroups();
    mounted = true;
    refresh();
  }

  function unmount() {
    var f = form(); if (!f) return;
    var role = f.getAttribute('data-tp-role'), tab = f.getAttribute('data-tp-tabindex');
    if (role) f.setAttribute('role', role);
    if (tab) f.setAttribute('tabindex', tab);
    f.removeAttribute('data-tp-role'); f.removeAttribute('data-tp-tabindex');
    f.querySelectorAll('details[data-tp-opened]').forEach(function (d) { d.open = false; d.removeAttribute('data-tp-opened'); });
    var a = document.activeElement;
    if (a && (f.contains(a) || (a.closest && a.closest('.tp-desk')))) {
      var btn = Array.prototype.find.call(document.querySelectorAll('facets-drawer[facet-drawer-btn]'), function (b) { return b.offsetParent !== null; });
      if (btn) btn.focus(); else if (a.blur) a.blur();
    }
    returnDesc();
    mounted = false;
  }

  function totalCount() {                                      // what is shown: Shopify's total less the products hidden so far
    var raw = shopifyTotal(section);
    if (raw === null) {
      var el = section.querySelector('[total-product-count]');
      var m = el && el.textContent.match(/\d[\d,]*/);
      return m ? m[0] : null;
    }
    return String(Math.max(0, raw - hiddenCount(section)));
  }

  function syncCounts() {
    var n = totalCount();
    var head = section.querySelector('[data-tp-filter-count]');
    if (head && n) { var t = '(' + n + (n === '1' ? ' product)' : ' products)'); if (head.textContent !== t) head.textContent = t; }
    var l = listing(), shown = section.querySelector('[data-tp-shown]');
    if (l && shown) {
      var k = String(l.querySelectorAll(':scope > .collection-product-item').length);
      if (shown.textContent !== k) shown.textContent = k;
    }
    var tot = section.querySelector('[data-tp-total]');
    if (tot && n && tot.textContent !== n) tot.textContent = n;
  }

  function columns(l) {
    var cols = getComputedStyle(l).gridTemplateColumns;
    return cols && cols !== 'none' ? cols.split(' ').filter(Boolean).length : 3;
  }

  function placeGuide() {
    var guides = section.querySelectorAll('[data-tp-guide]');
    for (var i = 1; i < guides.length; i++) guides[i].remove();
    var g = guides[0], l = listing();
    if (!g || !l) return;
    // the guide tile takes the 6th place in the grid (James, 8 Oct); with five products or fewer it follows the last one
    var items = l.querySelectorAll(':scope > .collection-product-item');
    if (!items.length) return;
    var after = items[Math.min(4, items.length - 1)];
    if (after.nextElementSibling !== g) after.after(g);
  }

  function markRatedRows() {
    var l = listing(); if (!l) return;
    var rows = {};
    l.querySelectorAll(':scope > .collection-product-item').forEach(function (item) {
      var card = item.querySelector('.tp-card'); if (!card) return;
      var top = Math.round(item.getBoundingClientRect().top + window.scrollY);
      (rows[top] = rows[top] || []).push(card);
    });
    Object.keys(rows).forEach(function (k) {
      var rated = rows[k].some(function (c) { return !!c.querySelector('[data-tp-rated]'); });
      rows[k].forEach(function (c) { c.classList.toggle('tp-row-rated', rated); });
    });
  }

  // The collection description (banner section) is shown under the page links on desktop (James, 7 Oct). The text stays in the
  // banner's HTML; this moves the node, and unmount() puts it back. A re-render empties the slot, so refresh() re-places it.
  var desc = document.querySelector('[id$="__banner"] [data-banner-description]');
  var descHome = desc && desc.parentNode, descNext = desc && desc.nextSibling;
  function placeDesc() {
    var slot = section.querySelector('[data-tp-desc-slot]');
    if (desc && slot && desc.parentNode !== slot) slot.appendChild(desc);
  }
  function returnDesc() {
    if (desc && descHome && desc.parentNode !== descHome) descHome.insertBefore(desc, descNext && descNext.parentNode === descHome ? descNext : null);
  }

  var pending = 0;
  function refresh() {
    if (!DESKTOP.matches || !mounted) return;
    cancelAnimationFrame(pending);
    pending = requestAnimationFrame(function () { openGroups(); syncCounts(); placeGuide(); placeDesc(); markRatedRows(); });
  }

  // sort: drive the theme's own engine through the drawer form's radio
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-tp-sort]');
    if (!sel) return;
    var f = form();
    var radio = f && f.querySelector('input[name="sort_by"][value="' + (window.CSS && CSS.escape ? CSS.escape(sel.value) : sel.value) + '"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      var u = new URL(window.location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page');
      window.location.assign(u.toString());
    }
  });

  // re-apply after facets.js re-renders and after "Load more" rebuilds the listing
  var obs = new MutationObserver(refresh);
  var grid = section.querySelector('[data-section_id]');
  if (grid) obs.observe(grid, { childList: true, subtree: true });
  var f0 = form();
  if (f0) obs.observe(f0, { childList: true, subtree: true });
  var countEl = section.querySelector('[total-product-count]');
  if (countEl) obs.observe(countEl, { childList: true, characterData: true, subtree: true });
  var rt = 0;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(refresh, 150); });
  window.addEventListener('load', refresh);

  function onChange() { if (DESKTOP.matches) mount(); else if (mounted) unmount(); }
  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', onChange); else DESKTOP.addListener(onChange);
  if (DESKTOP.matches) mount();
})();
